
export default {
  name: 'Spinner'
}
